<template>
  <div>
    <div class="page-title">Edit Content Block</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Content Block"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.content-blocks.page";

export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ContentBlock.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.ContentBlock.update(this.form);
      this.$router.push("/widgets/content-sections");
    },
  },
};
</script>

<style></style>
